import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

// neutral.backgroundLevel2 under the patient audience. Rendering this patient-facing page
// under that audience resolves input.background and 76 other tokens to the #ff22d6
// placeholder in aviary-tokens 2.2.2, so the value is inlined until patLight is fixed.
const patientBackgroundLevel2 = "#f0efec";

export const page = css`
  min-height: 100vh;
  background-color: ${patientBackgroundLevel2};
`;

export const content = (theme: Theme) => css`
  max-width: ${theme.ds5.column.web.container};
  margin: 0 auto;
  padding: ${theme.ds5.page.paddingT.medium} ${theme.ds5.column.web.margin}
    ${theme.ds5.spacing.gap.xxlarge};
`;

export const backButton = (theme: Theme) => css`
  margin-left: -${theme.ds5.spacing.gap.small};
`;

export const pageHead = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${theme.ds5.spacing.gap.large};
`;

export const eyebrow = (theme: Theme) => css`
  margin-top: ${theme.ds5.spacing.gap.xlarge};
  color: ${theme.ds5.success.text};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const columns = (theme: Theme) => css`
  display: grid;
  grid-template-columns: minmax(0, 8fr) minmax(0, 7fr);
  align-items: start;
  gap: ${theme.ds5.padding.dynamic[1000]};

  @media (max-width: ${dimensions.phoneLargeMax}) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const sideColumn = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.medium};
`;
